var React = require('react');

function Error (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"close"},[React.createElement("circle",{"id":"Oval","fill":"#A92200","cx":"7.5","cy":"7.5","r":"7.5","key":0}),React.createElement("g",{"id":"Group-18","transform":"translate(7.500000, 7.500000) rotate(45.000000) translate(-7.500000, -7.500000) translate(3.000000, 3.000000)","stroke":"#FFFFFF","strokeLinecap":"round","key":1},[React.createElement("line",{"x1":"0","y1":"4.5","x2":"9","y2":"4.5","id":"Path-7","key":0}),React.createElement("line",{"x1":"0","y1":"4.5","x2":"9","y2":"4.5","id":"Path-7","transform":"translate(4.500000, 4.500000) rotate(90.000000) translate(-4.500000, -4.500000) ","key":1})])])));
}

Error.defaultProps = {"viewBox":"0 0 15 15","version":"1.1"};

module.exports = Error;

Error.default = Error;
